module.exports = __webpack_public_path__ + "img/1f919-1f3ff.85a1634.svg";